/// The handoff boundary for live "Handoff" levels — a dashed ring marking the
/// edge of your airspace. Traffic you aren't landing should be handed off to
/// Center before it crosses; an aircraft that leaves it unworked counts against
/// the shift. Drawn once at mount; the ring is static (the airspace doesn't move).

import { Container, Graphics, Text } from 'pixi.js'

const BOUNDARY_COLOR = 0x38bdf8 // ATC sky-blue accent

export class HandoffBoundaryLayer extends Container {
  constructor(centerX: number, centerY: number, radiusPx: number) {
    super()

    // Soft outer glow.
    const glow = new Graphics()
    glow.circle(centerX, centerY, radiusPx)
    glow.stroke({ width: 7, color: BOUNDARY_COLOR, alpha: 0.08 })
    this.addChild(glow)

    // Dashed boundary ring.
    const ring = new Graphics()
    const segments = 96
    const dashFraction = 0.62
    for (let i = 0; i < segments; i++) {
      const a0 = (i / segments) * Math.PI * 2
      const a1 = a0 + (dashFraction * (Math.PI * 2)) / segments
      ring.moveTo(centerX + Math.cos(a0) * radiusPx, centerY + Math.sin(a0) * radiusPx)
      ring.arc(centerX, centerY, radiusPx, a0, a1)
    }
    ring.stroke({ width: 1.6, color: BOUNDARY_COLOR, alpha: 0.5 })
    this.addChild(ring)

    // Label at the top of the ring.
    const label = new Text({
      text: 'HANDOFF BOUNDARY',
      style: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 11,
        fill: BOUNDARY_COLOR,
        fontWeight: '700',
        letterSpacing: 2,
      },
    })
    label.anchor.set(0.5, 0.5)
    label.alpha = 0.7
    label.position.set(centerX, centerY - radiusPx)
    this.addChild(label)
  }
}
